module.exports = __webpack_public_path__ + "static/media/physiotherapist-and-boy-holding-ball-pxfq-9-hy.2e8d2b6b.png";